import NamedContact from "../named-contact";
import CredentialedResource from "./credentialed-resource";

export default class ProfessionalProvider
  extends CredentialedResource
  implements NamedContact
{
  npi: string;
  dea: string;
  taxonomyCode: string;
  taxId: string;
  attachedToPatients: boolean;
}



// WEBPACK FOOTER //
// ./src/models/resource-management/professional-provider.ts